import Encoding from "encoding-japanese";

export const isUTF8WithBOM = (value: string): boolean => {
	if (Encoding.detect(value) !== "UTF8") return false;
	return value.codePointAt(0) === 0xef && value.codePointAt(1) === 0xbb && value.codePointAt(2) === 0xbf;
};
